export const DEFAULT_ORDER_INDEX = 1000

export const FIELD_SIZE = 'col-8'
export const LIST_LEFT_PADDING = { paddingLeft: '20px' }

export enum EtbRoleApps {
  all = 'all',
  developer = 'developer',
  monitor = 'monitor',
  services = 'services'
}

export enum EtbPermissionFilters {
  all = 'all',
  referenced = 'referenced',
  special = 'special'
}

// Names of permission referenced in AMP. This is only a subset of all permissions.
export enum Permissions {
  canEditCompanySubscriptionSettings = 'canEditCompanySubscriptionSettings',
  canEditCompanyUsers = 'canEditCompanyUsers',
  canInviteUsers = 'canInviteUsers',
  etbAdminCanEditCompanies = 'etbAdminCanEditCompanies',
  etbAdminCanEditEtbAdminRoles = 'etbAdminCanEditEtbAdminRoles',
  etbAdminCanRoamCompanyAccounts = 'etbAdminCanRoamCompanyAccounts',
  monitorAdminCanEditMonitorAdminRoles = 'monitorAdminCanEditMonitorAdminRoles',
  servicesCanEditCompanySubscriptionSettings = 'servicesCanEditCompanySubscriptionSettings',
  servicesCanEditCompanyUsers = 'servicesCanEditCompanyUsers',
  servicesCanInviteUsers = 'servicesCanInviteUsers'
}
